import "./styles.css";
import { ReactComponent as TrashIcon } from "../../../assets/svg/icons/trash.svg";
import { ButtonOnlyTitle } from "../../Buttons/ButtonOnlyTitle/Index";
import { useTranslation } from "react-i18next";

type FooterEditOnboardingProps = {
  undoFunction: (data: any) => void;
  saveFunction: (data: any) => void;
  deleteFunction?: (data: any) => void;
  onlyRead?: boolean;
  disabledSubmit?: boolean;
  disabledSave?: boolean;
  isNew: boolean;
  saveLabel?: string;
};

export function FooterEditOnboarding({
  undoFunction,
  saveFunction,
  deleteFunction,
  onlyRead = false,
  isNew = false,
  disabledSubmit = false,
  disabledSave = false,
  saveLabel

}: FooterEditOnboardingProps) {
  const { t } = useTranslation();
  return (
    <div className="footer__EditOnboarding">
      {onlyRead && !isNew ? (
        ""
      ) : (
        <div className="footer__formEditOnboarding">
          <ButtonOnlyTitle
            title={t("editFooter.cancel")}
            theme="light"
            onClick={undoFunction}
            type="button"
            disabled={disabledSubmit}
          />

          <ButtonOnlyTitle
            title={saveLabel || t("editFooter.save")}
            theme="info"
            onClick={saveFunction}
            type="submit"
            disabled={disabledSubmit || disabledSave}
          />
        </div>
      )}

      {!isNew && deleteFunction ? (
        <button
          className={`delete__button${onlyRead ? "-readValues" : ""}`}
          onClick={deleteFunction}
          type="button"
          title={t("editFooter.delete")}
          aria-label={t("editFooter.delete")}
        >
          <TrashIcon />
        </button>
      ) : (
        ""
      )}
    </div>
  );
}
